// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileClock(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileClock" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M12.625 13.6875V11H11.375V14.3125L13.625 16L14.375 15L12.625 13.6875Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 21V3H14L19 7V21H5ZM16.5 13.5C16.5 15.9853 14.4853 18 12 18C9.51471 18 7.5 15.9853 7.5 13.5C7.5 11.0147 9.51471 9 12 9C14.4853 9 16.5 11.0147 16.5 13.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileClock.js.map